import { PromptElementImplInterface } from './PromptElementImplInterface';
import { DataStateChangeEvent, RangeSliderController } from '@sas-dvr/ltjs-bird';
import { ReportState } from '@sas-dvr/internal-va-react-core/store/rootReducer';
import { SliderState } from '@sas-dvr/internal-va-react-core/store/birdElement/sliderState';
import { filter, tap, ignoreElements, map, mergeMap, distinctUntilChanged } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { PortableEvent } from '@sas-dvr/ltjs-commons';
import { StateObservable } from 'redux-observable';
import { AnyAction } from 'redux';

function getData(controller: RangeSliderController, dualRange: boolean) {
  //Port from OpenUI
  // OpenUI has some _dataRangeUnset logic that was not ported.
  const defaultRange = controller.getDefaultRange();
  let currentSelectedRange = controller.getCurrentSelectedRange();
  let currentDataRange = controller.getCurrentDataRange();

  if (!currentDataRange) {
    currentDataRange = defaultRange;
    if (!currentDataRange) {
      currentDataRange = [0, 100];
    }
  }
  if (!currentSelectedRange) {
    currentSelectedRange = defaultRange;
    if (!currentSelectedRange) {
      currentSelectedRange = currentDataRange;
      if (dualRange) {
        controller.setCurrentSelectedRange(currentSelectedRange[0], currentSelectedRange[1]);
      } else {
        controller.setCurrentSelectedValue(currentSelectedRange[0]);
      }
    }
  }
  const values = {
    min: currentSelectedRange[0],
    max: dualRange ? currentSelectedRange[1] : undefined,
  };
  return {
    values,
    sliderState: values,
    range: { min: currentDataRange[0], max: currentDataRange[1] },
    format: controller.getFormatName() || undefined,
    horizontal: controller.isHorizontal(),
  };
}

export class SliderImpl implements PromptElementImplInterface {
  private _controller: RangeSliderController;
  private _id: string;
  private _dualRange: boolean;
  private _ignoreValueChange: boolean = false;

  constructor(controller: RangeSliderController, id: string, dualRange: boolean) {
    this._controller = controller;
    this._id = id;
    this._dualRange = dualRange;
  }

  createElement() {
    return SliderState.actions.add(this._id, {
      ...getData(this._controller, this._dualRange),
    });
  }

  deleteElement() {
    return SliderState.actions.delete(this._id);
  }

  handleDataChange(dataChange$: Observable<DataStateChangeEvent>) {
    return dataChange$.pipe(
      map(() => {
        return SliderState.actions.update(this._id, getData(this._controller, this._dualRange));
      })
    );
  }

  handleValueChanged(valueChange$: Observable<PortableEvent>) {
    return valueChange$.pipe(
      mergeMap(() => {
        if (this._ignoreValueChange) {
          return EMPTY;
        }
        return of(SliderState.actions.update(this._id, getData(this._controller, this._dualRange)));
      })
    );
  }

  handleActions(_myActions$: Observable<AnyAction>, state$: StateObservable<ReportState>) {
    return state$.pipe(
      map((aState) => aState.birdElements.Slider[this._id]),
      filter((myState): myState is Exclude<typeof myState, undefined> => myState !== undefined),
      map((myState) => myState.values),
      distinctUntilChanged(),
      tap((values) => {
        this._ignoreValueChange = true;
        if (this._dualRange) {
          this._controller.setCurrentSelectedRange(values.min, values.max || 0);
        } else {
          this._controller.setCurrentSelectedValue(values.min);
        }
        this._ignoreValueChange = false;
      }),
      ignoreElements()
    );
  }
}
